import type { FC } from 'react';
import { useState } from 'react';
import { Box, Button, Chip } from '@mui/material';
import type { RedditKeyword } from '../types';

const VISIBLE_KEYWORDS_LIMIT = 5;

const KEYWORD_CHIP_SX = {
  height: 18,
  fontSize: '0.68rem',
  borderRadius: '4px',
} as const;

interface RedditPostKeywordsProps {
  keywords: RedditKeyword[];
}

const RedditPostKeywords: FC<RedditPostKeywordsProps> = ({ keywords }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (keywords.length === 0) {
    return null;
  }

  const remainingCount = keywords.length - VISIBLE_KEYWORDS_LIMIT;
  const visibleKeywords = isExpanded ? keywords : keywords.slice(0, VISIBLE_KEYWORDS_LIMIT);

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 0.5 }}>
      {visibleKeywords.map((keyword) => (
        <Chip
          key={keyword.id}
          label={keyword.phrase}
          size="small"
          variant="outlined"
          sx={KEYWORD_CHIP_SX}
        />
      ))}
      {remainingCount > 0 && (
        <Button
          size="small"
          onClick={() => { setIsExpanded((prev) => !prev); }}
          sx={{
            minWidth: 0,
            p: 0.25,
            textTransform: 'none',
            fontSize: '0.68rem',
            lineHeight: 1.2,
          }}
        >
          {isExpanded ? 'Show less' : `Show more (${remainingCount})`}
        </Button>
      )}
    </Box>
  );
};

export default RedditPostKeywords;
